var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flower-spinner", style: _vm.spinnerStyle }, [
    _c(
      "div",
      { staticClass: "dots-container", style: _vm.dotsContainerStyle },
      [
        _c("div", { staticClass: "bigger-dot", style: _vm.biggerDotStyle }, [
          _c("div", { staticClass: "smaller-dot", style: _vm.smallerDotStyle })
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }